import React, { useEffect } from "react";
import { Row, Col, Container } from "react-bootstrap";
import TopNavigation from "../../components/TopNavigation";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import { Base } from "../../components/RootLayout";
import { connect } from "react-redux";
import "./style.scss";

const ContentItem = ({ imgsrc, url, children }) => {
  return (
    <a href={url} target="_blank" rel="noreferrer">
      <Row>
        <Col xs={3} sm={2} md={2}>
          <div className="support-img-container">
            <center>
              <img src={imgsrc} alt="content_item_image" />
            </center>
          </div>
        </Col>
        <Col xs={9} sm={10} md={10} className="zeropm">
          <div className="support-content-item">{children}</div>
        </Col>
      </Row>
    </a>
  );
};

const SupportContactPage = (props) => {
  const { getContactList, contactList } = props;
  useEffect(() => {
    getContactList();
  }, []);
  return (
    <Base>
      <div className="contact-support">
        <TopNavigation
          titlePage="Contact"
          toPath={PageRoutes.support}
          setBorder={true}
          showRightIcon={false}
          iconLeft={Assets.iconBack}
          iconRight={Assets.iconFilter}
        />
        <Container>
          <Row className="p-1 emergency-call">
            <Col xs={10} sm={10} md={10}>
              Emergency Call
            </Col>
            <Col xs={2} sm={2} md={2}>
              <img
                src={Assets.iconSupportCall}
                className="icon-call p-1"
                alt="contact"
              />
            </Col>
          </Row>
          <ContentItem
            imgsrc={Assets.iconSupportCall}
            url={
              "https://api.whatsapp.com/send?phone=" +
              contactList.phone +
              "&text=Thank%20you%20for%20reaching%20us!%20How%20can%20we%20help%20you?"
            }
          >
            <h6>Phone</h6>
            <p className="lbl-info">{contactList.phone}</p>
          </ContentItem>
          <br />
          <ContentItem imgsrc={Assets.iconWeb} url={contactList.website}>
            <h6>Website </h6>
            <p className="lbl-info">{contactList.website}</p>
          </ContentItem>
          <br />
          <ContentItem
            imgsrc={Assets.iconEmail}
            url={"mailto:" + contactList.email}
          >
            <h6>Email </h6>
            <p className="lbl-info">{contactList.email}</p>
          </ContentItem>
        </Container>
      </div>
    </Base>
  );
};
const mapStateToProps = (state) => ({
  contactList: state.ContactSM.contactList,
});
const mapDispatchToProps = (dispatch) => ({
  getContactList: dispatch.ContactSM.getContactList,
});

export default connect(mapStateToProps, mapDispatchToProps)(SupportContactPage);
